module.exports = __webpack_public_path__ + "img/notificationsMobile.2db97095.svg";